import DesignerActions from './designer-actions';
import NotificationActions from './notification-list-actions';
import TemplatePickerActions from './template-picker-actions';

export default {
  ...DesignerActions,
  ...NotificationActions,
  ...TemplatePickerActions,
};
